// extracted by mini-css-extract-plugin
export default {"skeleton-element":"Skeleton_skeleton-element__Lz0ne","skeleton-animation":"Skeleton_skeleton-animation__wmVbI"};